if (!customElements.get("payment-options-widget")) {
    customElements.define(
      "payment-options-widget",
      class PaymentOptionsWidget extends HTMLElement {
        constructor() {
            super();
            this.subscriptionOption = this.querySelector('.subscription_option');
            this.onetimeOption = this.querySelector('.onetime_option');
            this.isSubscription = true;
            this.oneTimeProductId = this.getAttribute('one-time-product-id');
            this.oneTimeVariantId = this.getAttribute('one-time-variant-id');
        }
    
        connectedCallback() {
            this.subscriptionOption.addEventListener('click', this.activeOption.bind(this));
            this.onetimeOption.addEventListener('click', this.activeOption.bind(this));

            this.subscriptionOption.addEventListener('keydown', (e) => {
              if (e.key === 'Enter') this.activeOption(e);
            });
            this.onetimeOption.addEventListener('keydown', (e) => {
              if (e.key === 'Enter') this.activeOption(e);
            });
        }
    
        activeOption(event) {
            this.clearOptions();
            const target = event.target.closest('.option_wrapper');
            if (!target) return;
            target.classList.add('selected');
            const deliveryFrequencyWidget = document.querySelector('delivery-frequency-widget');
            const quantitySelector = document.querySelector('.qty-btn-section');
            if (deliveryFrequencyWidget && target.classList.contains('onetime_option')) {
                deliveryFrequencyWidget.close();
                deliveryFrequencyWidget.hide();
                this.isSubscription = false;
                const customizableAssortment = document.querySelector('customizable-assortment');
                if (customizableAssortment && this.productAbsorbencyQuantity > 0) {
                    customizableAssortment.maxAbsorbencyQuantity = this.productAbsorbencyQuantity;
                    customizableAssortment.resetAbsorbency();
                    customizableAssortment.updateProgressBar();
                    customizableAssortment.updateAbsorbencyData();
                    customizableAssortment.updateStatuSubmit();
                }
                const rechargeBundleVariantOptions = document.querySelector('recharge-bundle-variant-options');
                if (rechargeBundleVariantOptions) {
                    rechargeBundleVariantOptions.maxAbsorbencyQuantity = this.productAbsorbencyQuantity;
                }
            } else {
                deliveryFrequencyWidget.show();
                this.isSubscription = true;
                if (deliveryFrequencyWidget.selectedOption) {
                    //update recharge-bundle-variant-options
                    deliveryFrequencyWidget.updateMaxQuantity();
                    //update customizable-assortment
                    deliveryFrequencyWidget.updateCustomizableAssortment();
                }
            }
        }
    
        clearOptions() {
            this.onetimeOption.classList.remove('selected');
            this.subscriptionOption.classList.remove('selected');
        }
    
        updateSubscriptionContent(p, content, absorbencyQty) {
            const price = parseInt(p)
            const absorbencyQuantity = parseInt(absorbencyQty)
            const title = this.querySelector('.option_title .h4');
            title.innerHTML = "$" + parseFloat(price / 100).toFixed(2) + "/" + content;
            const discountMessage = this.querySelector('.discount_message');
            let discount = (this.productOriginalPrice / this.productAbsorbencyQuantity - price / absorbencyQuantity) / this.productOriginalPrice * this.productAbsorbencyQuantity;
            discount = parseInt(discount * 100) + "%";
            discountMessage.innerHTML = 'Up to ' + discount + ' off';
        }
    
        get productOriginalPrice() {
            return parseInt(this.getAttribute('product-original-price'))
        }
        get productAbsorbencyQuantity() {
            return parseInt(this.getAttribute('product-aborbency-quantity'));
        }
      }
    );
}

if (!customElements.get("delivery-frequency-widget")) {
    customElements.define(
      "delivery-frequency-widget",
      class DeliveryFrequencyWidget extends HTMLElement {
        constructor() {
            super();
    
            this.preview = this.querySelector('.frequency_selected_preview');
            this.selector = this.querySelector('.frequency-options-wrapper');
            this.options = this.selector.querySelectorAll('.frequency_option');
            this.selectedProductId = this.getAttribute('data-product-id');
            this.selectedVariantId = this.getAttribute('data-variant-id');
            this.sellingPlan = this.getAttribute('data-selling-plan');
            this.frequency = this.getAttribute('data-frequency');
            this.internalUnit = this.getAttribute('data-interunal_unit');
        }
    
        connectedCallback() {
            this.preview.addEventListener('click', () => {
                this.selector.classList.toggle('expanded');
                this.updateTabIndex();
            });
            this.preview.addEventListener('keydown', (e) => {
              if (e.key === 'Enter') {
                this.selector.classList.toggle('expanded');
                this.updateTabIndex();
              }
            });
            this.options.forEach(option => {
              option.addEventListener('click', this.handleOptionClick.bind(this));
              option.addEventListener('keydown', (e) => {
                if (e.key === 'Enter') this.handleOptionClick(e);
              });
            });

            // Update discount message
            const selectedOption = Array.from(this.options).find(option => option.classList.contains('selected'));
            if (selectedOption) {
                const price = selectedOption.getAttribute('data-price');
                const absorbencyQuantity = selectedOption.getAttribute('data-absorbency-quantity');
                
                const paymentOptionsWidget = document.querySelector('payment-options-widget');
                let discount = (paymentOptionsWidget.productOriginalPrice / paymentOptionsWidget.productAbsorbencyQuantity - price / absorbencyQuantity) / paymentOptionsWidget.productOriginalPrice * paymentOptionsWidget.productAbsorbencyQuantity;
                const discountMessage = paymentOptionsWidget.querySelector('.discount_message');
                discount = parseInt(discount * 100) + "%";
                discountMessage.innerHTML = 'Up to ' + discount + ' off';
            }

        }

        updateTabIndex(){
            const isExpanded = this.selector.classList.contains('expanded');
            this.options.forEach(option => {
              option.setAttribute('tabindex', isExpanded ? '0' : '-1');
            });
        }
    
        handleOptionClick(event) {
            this.selectedOption = event.target.closest('.frequency_option');
            this.updateOptions();
            this.updatePreview();
            this.updatePaymentOptions();
            //update recharge-bundle-variant-options
            this.updateMaxQuantity();
            //update customizable-assortment
            this.updateCustomizableAssortment();
            this.updateProductAndVariant();
            this.close();
        }
    
        updateOptions() {
            this.options.forEach(option => {
                if (option == this.selectedOption) {
                    option.classList.add('selected');
                } else {
                    option.classList.remove('selected');
                }
            })
        }
    
        updatePreview() {
            const previewDetails = this.preview.querySelector('.details');
            const update = this.selectedOption.querySelector('.details');
            if (update && previewDetails) {
                previewDetails.innerHTML = update.innerHTML;
            }
            const previewBoxInfo = this.preview.querySelector('.box-info');
            const updateBoxInfo = this.selectedOption.querySelector('.box-info');
            if (updateBoxInfo && previewBoxInfo) {
                previewBoxInfo.innerHTML = updateBoxInfo.innerHTML;
            }
        }
    
        updateProductAndVariant() {
            this.selectedProductId = this.selectedOption.getAttribute('data-product-id');
            this.selectedVariantId = this.selectedOption.getAttribute('data-variant-id');
            this.sellingPlan = this.selectedOption.getAttribute('data-selling-plan');
            this.frequency = this.selectedOption.getAttribute('data-frequency');
        }
    
        updatePaymentOptions() {
            const price = this.selectedOption.getAttribute('data-price');
            const title = this.selectedOption.getAttribute('data-title');
            const absorbencyQty = this.selectedOption.getAttribute('data-absorbency-quantity');
            const paymentOptionsWidget = document.querySelector('payment-options-widget');
            if (!paymentOptionsWidget) return;
            paymentOptionsWidget.updateSubscriptionContent(price, title, absorbencyQty);
        }
    
        updateMaxQuantity() {
            const maxAbsorbencyQuantity = parseInt(this.selectedOption.getAttribute('data-absorbency-quantity'));
            const rechargeBundleVariantOptions = document.querySelector('recharge-bundle-variant-options');
            if (rechargeBundleVariantOptions) {
                rechargeBundleVariantOptions.maxAbsorbencyQuantity = maxAbsorbencyQuantity;
            }
        }
  
        updateCustomizableAssortment() {
          const maxAbsorbencyQuantity = parseInt(this.selectedOption.getAttribute('data-absorbency-quantity'));
          const customizableAssortment = document.querySelector('customizable-assortment');
          if (customizableAssortment && maxAbsorbencyQuantity > 0) {
              customizableAssortment.maxAbsorbencyQuantity = maxAbsorbencyQuantity;
              customizableAssortment.resetAbsorbency();
              customizableAssortment.updateProgressBar();
              customizableAssortment.updateAbsorbencyData();
              customizableAssortment.updateStatuSubmit();
          }
        }
    
        close() {
            this.selector.classList.remove('expanded');
            this.updateTabIndex();
        }
    
        open() {
            this.selector.classList.add('expanded');
        }
    
        hide() {
            this.classList.add('hide');
        }
    
        show() {
            this.classList.remove('hide');
        }
      }
    );
}

if (!customElements.get("customizable-assortment")) {
    customElements.define(
      "customizable-assortment",
      class CustomizableAssortment extends HTMLElement {
        constructor() {
            super();
            this.assortmentWrapper = this.querySelector(".assortment__wrapper");
            this.progressBar = this.querySelector('.progress_bar');
            this.plusButtons = this.querySelectorAll('.options--row__buttons button.plus');
            this.minusButtons = this.querySelectorAll('.options--row__buttons button.minus');
            this.maxAbsorbencyQuantity = parseInt(this.getAttribute('product-absorbency-quantity'));
            this.currentAbsobencyQuantity = this.maxAbsorbencyQuantity;
            this.NUMBEROFBOX = parseInt(this.getAttribute('absorbency-number-of-box'));
            this.absorbencyInputs = this.querySelectorAll('input');
            this.absorbencyData = {};
            this.rechargeBundleCollectionId = this.getAttribute('recharge-bundle-collection-id');
            this.rechargeBundleSubProductId = this.getAttribute('recharge-bundle-sub-product-id');
        }
    
        connectedCallback() {
            this.plusButtons.forEach(btn => btn.addEventListener('click', this.handleAdd.bind(this)));
            this.minusButtons.forEach(btn => btn.addEventListener('click', this.handleMinus.bind(this)));
            this.updateProgressBar();
            this.presetAbsorbencyData();// ONLY working with subscription page in Customer Portal.
            this.updateAbsorbencyData();
            const rechargeSubProductVariants = this.querySelector('[type="application/json"]');
            this.rechargeSubProductVariants = JSON.parse(rechargeSubProductVariants.textContent);
        }
    
        handleAdd(event) {
            const rowInput = event.target.closest('.options--row__input');
            const input = rowInput.querySelector('input');
            if (this.currentAbsobencyQuantity >= this.maxAbsorbencyQuantity) return;
            input.value = parseInt(input.value) + 1;
            this.currentAbsobencyQuantity += 1;
            this.updateLabel(rowInput, input.value);
            this.updateProgressBar();
            this.updateAbsorbencyData();
            this.updateStatuSubmit();
        }
    
        handleMinus(event) {
            const rowInput = event.target.closest('.options--row__input');
            const input = rowInput.querySelector('input');
            if (input.value < 1) return;
            input.value = parseInt(input.value) - 1;
            this.currentAbsobencyQuantity -= 1;
            this.updateLabel(rowInput, input.value);
            this.updateProgressBar();
            this.updateAbsorbencyData();
            this.updateStatuSubmit();
        }
    
        updateLabel(rowInput, value) {
            const label = rowInput.querySelector('.absorbencies_quantity');
            label.innerHTML = value * this.NUMBEROFBOX;
        }
    
        presetAbsorbencyData() {
            const assortmentSettings = document.querySelector('.assortment_setting');
            if (!assortmentSettings) return;
            this.absorbencyInputs.forEach(input => {
                const inputName = input.name.replace('labels', "").replace('[', "").replace("]", "").replace("+", "_plus")
                const absorbency = document.querySelector(`.assortment_setting div[data-name="${inputName}"]`);
                const rowInput = input.closest('.options--row__input');
                if (absorbency) {
                    const value = parseInt(absorbency.getAttribute('data-value')) / this.NUMBEROFBOX;
                    input.value = value;
                    input.setAttribute('data-value', value);
                    this.updateLabel(rowInput, value);
                } else {
                    input.value = 0;
                    input.setAttribute('data-value', 0);
                    this.updateLabel(rowInput, 0);
                }
            })
    
        }
    
        updateAbsorbencyData() {
            const data = {};
            this.absorbencyInputs.forEach(input => {
                data[`${input.id}`] = input.value;
            });
            this.absorbencyData = data;
            console.log(this.absorbencyData);
        }
    
        updateProgressBar() {
            const currentLabel = this.progressBar.querySelector('.custom-current-qty');
            const totalLabel = this.progressBar.querySelector('.custom-total-qty');
            console.log('16ct bundle product');
            console.log(this.maxAbsorbencyQuantity);
            console.log(this.NUMBEROFBOX);
            if (this.currentAbsobencyQuantity < this.maxAbsorbencyQuantity) {
                currentLabel.classList.add('warning');
            } else {
                currentLabel.classList.remove('warning');
            }
            currentLabel.innerHTML = this.currentAbsobencyQuantity * this.NUMBEROFBOX;
            totalLabel.innerHTML = this.maxAbsorbencyQuantity * this.NUMBEROFBOX;
    
            const progressInnerBar = this.progressBar.querySelector('.progress-bar-ui-inner');
            progressInnerBar.style.width = `${this.currentAbsobencyQuantity / this.maxAbsorbencyQuantity * 100}%`;
    
            const helpTextContainer = document.querySelector(".custom-assortment-help-text");
            const helpText = document.querySelector(".custom-assortment-help-text > span");
            if (this.currentAbsobencyQuantity < this.maxAbsorbencyQuantity) {
                progressInnerBar.classList.remove('fill');
                if (helpTextContainer) {
                    helpTextContainer.classList.remove("visibility-hidden");
                    helpText.innerHTML = 'Add 16 total tampons to your box to add to your cart';
                }
            } else {
                progressInnerBar.classList.add('fill');    
                if (helpTextContainer) {
                    helpTextContainer.classList.add("visibility-hidden");
                }
            }
        }
    
        updateStatuSubmit() {
            const rechargeBtn = document.querySelector('recharge-bundle-add-to-cart-16ct');
            const rechargeSubscriptionBtn = document.querySelector('recharge-bundle-edit-subscription');
            if(rechargeBtn){
              if(this.currentAbsobencyQuantity == this.maxAbsorbencyQuantity) {
                rechargeBtn.button.classList.remove('disabled');
              }else{
                rechargeBtn.button.classList.add('disabled');
              }
            }
    
            const helpTextContainer = document.querySelector(".custom-assortment-help-text");
            const helpText = document.querySelector(".custom-assortment-help-text > span");
            Object.entries(this.absorbencyData).forEach(([key, val]) => {
              const value = parseInt(val);
              const variant = this.rechargeSubProductVariants.find(v => v.title == key);
              if(value > 0 && !variant.available){
                rechargeBtn?.button.classList.add('disabled');
                rechargeSubscriptionBtn?.button.classList.add('disabled');
                if(helpText && helpTextContainer){
                  helpText.innerHTML = `${key} is currently Out of Store.`
                  helpTextContainer.classList.remove("visibility-hidden");
                }
              }
            });
        }
    
        resetAbsorbency() {
            this.currentAbsobencyQuantity = 0;
            this.absorbencyInputs.forEach(input => {
                const rowInput = input.closest('.options--row__input');
                if (input.id == 'Regular' || input.id == 'Super' || input.id == 'Heavy') {
                    input.value = this.maxAbsorbencyQuantity / 2;
                    this.currentAbsobencyQuantity += this.maxAbsorbencyQuantity / 2;
                    this.updateLabel(rowInput, input.value);
                } else {
                    input.value = 0;
                }
                this.updateLabel(rowInput, input.value);
            });
        }
      }
    );
}

if (!customElements.get("recharge-bundle-edit-subscription")) {
    customElements.define(
      "recharge-bundle-edit-subscription",
      class RechargeBundleEditSubscription extends HTMLElement {
        constructor() {
            super();
            this.button = this.querySelector('button');
            this.referencedProductHandle = this.getAttribute('data-referenced-product-handle');
            this.storeIdentifier = this.getAttribute('data-store-identifier');
            this.subscriptionId = document.querySelector('input[name="subscription_id"]')?.value;
        }
    
        async connectedCallback() {
            recharge.init({
                storeIdentifier: this.storeIdentifier, // On Shopify this should be your myshopify.com domain
                // required for Storefront API access
                storefrontAccessToken: 'strfnt_f16386bfed7c30d02ab8e5bbd1f6286eaa93d2e54cca7c33875c6ead2007f2c7'
            });
            this.button.addEventListener('click', this.handleSubmit.bind(this));
            this.deliveryFrequencyWidget = document.querySelector('delivery-frequency-widget');
            this.customizableAssortment = document.querySelector('customizable-assortment');
            this.paymentOptionsWidget = document.querySelector('payment-options-widget');
        }
    
        async handleSubmit(e) {
            console.log('16ct bundle product');
            e.preventDefault();
            if (!this.subscriptionId) return;
    
            if (this.button.classList.contains('disabled')) return;
    
            this.button.classList.add('loading');
            this.button.classList.add('disabled');
    
            const bundleParentData = {
                variantId: this.deliveryFrequencyWidget.selectedVariantId,
                productId: this.deliveryFrequencyWidget.selectedProductId,
                sellingPlan: this.deliveryFrequencyWidget.sellingPlan,
                frequency: parseInt(this.deliveryFrequencyWidget.frequency),
                internalUnit: this.deliveryFrequencyWidget.internalUnit
            }
    
            const aborbencies = this.customizableAssortment.absorbencyData;
            const bundleCollectionId = this.customizableAssortment.rechargeBundleCollectionId;
            const bundleSubProductId = this.customizableAssortment.rechargeBundleSubProductId;
            const bundleSubProductVariants = this.customizableAssortment.rechargeSubProductVariants;
            const selections = [];
            const properties = [];
    
            Object.entries(aborbencies).forEach(([key, value]) => {
                if (value > 0) {
                    const data = {};
                    data.collection_id = bundleCollectionId;
                    data.collection_source = 'shopify';
                    data.external_product_id = bundleSubProductId;
                    data.quantity = parseInt(value);
                    data.external_variant_id = bundleSubProductVariants.find(v => v.title == key).id.toString();
                    switch (key) {
                        case 'Light':
                            properties.push({
                                name: 'Light',
                                value: `${parseInt(value) * 8}`
                            })
                            break;
                        case 'Regular':
                            properties.push({
                                name: 'Regular',
                                value: `${parseInt(value) * 8}`
                            });
                            break;
                        case 'Super':
                            properties.push({
                                name: 'Super',
                                value: `${parseInt(value) * 8}`
                            })
                            break;
                        case 'Super+':
                            properties.push({
                                name: 'Super+',
                                value: `${parseInt(value) * 8}`
                            });
                            break;
                    }
                    selections.push(data);
                }
            });
    
            properties.push({
                name: '_referenced_product_handle',
                value: `${this.referencedProductHandle}`
            })
    
            const bundle = {
                properties: properties,
                external_product_id: { ecommerce: bundleParentData.productId.toString() },
                external_variant_id: { ecommerce: bundleParentData.variantId.toString() },
                items: selections,
                charge_interval_frequency: bundleParentData.frequency,
                order_interval_frequency: bundleParentData.frequency,
                order_interval_unit: bundleParentData.internalUnit
            };
            console.log('bundle', bundle);
            try {
                const session = await recharge.auth.loginShopifyAppProxy();
                const result = await recharge.bundle.updateBundle(session, this.subscriptionId, bundle);
                console.log(result);
                window.location.href = window.LOLA_PRODUCT.metadata.rechargeInfo.subscriptionsListUrl;
            } catch (error) {
                console.log(error);
            }
        }
    
    }
    );
}

if (!customElements.get("recharge-bundle-add-to-cart-16ct")) {
    customElements.define(
        "recharge-bundle-add-to-cart-16ct",
        class RechargeBundleAddToCart16ct extends HTMLElement {
            constructor() {
                super();
                this.button = this.querySelector('button');
                this.referencedProductHandle = this.getAttribute('data-referenced-product-handle');
                this.storeIdentifier = this.getAttribute('data-store-identifier');
            }
        
            connectedCallback() {
                recharge.init({ storeIdentifier: this.storeIdentifier });
                this.button.addEventListener('click', this.handleSubmit.bind(this));
                this.deliveryFrequencyWidget = document.querySelector('delivery-frequency-widget');
                this.customizableAssortment = document.querySelector('customizable-assortment');
                this.paymentOptionsWidget = document.querySelector('payment-options-widget');
            }
        
            async handleSubmit(e) {
                e.preventDefault();
        
                if (this.button.classList.contains('disabled')) return;
        
                let bundleParentData;
                const quantity = document.querySelector('.qty-btn-section select[name="quantity"]');
                if (this.paymentOptionsWidget.isSubscription) {
                    bundleParentData = {
                        variantId: this.deliveryFrequencyWidget.selectedVariantId,
                        productId: this.deliveryFrequencyWidget.selectedProductId,
                        sellingPlan: this.deliveryFrequencyWidget.sellingPlan,
                        quantity: quantity ? quantity.value : 1
                    }
                } else {
                    bundleParentData = {
                        variantId: this.paymentOptionsWidget.oneTimeVariantId,
                        productId: this.paymentOptionsWidget.oneTimeProductId,
                        sellingPlan: null,
                        quantity: quantity ? quantity.value : 1
                    }
                }
        
                const aborbencies = this.customizableAssortment.absorbencyData;
                const bundleCollectionId = this.customizableAssortment.rechargeBundleCollectionId;
                const bundleSubProductId = this.customizableAssortment.rechargeBundleSubProductId;
                const bundleSubProductVariants = this.customizableAssortment.rechargeSubProductVariants;
                const selections = [];
                const properties = {};
        
                Object.entries(aborbencies).forEach(([key, value]) => {
                    if (value > 0) {
                        const data = {};
                        data.collectionId = bundleCollectionId;
                        data.externalProductId = bundleSubProductId;
                        data.quantity = parseInt(value);
                        data.externalVariantId = bundleSubProductVariants.find(v => v.title == key).id;
                        switch (key) {
                            case 'Light':
                                properties['Light'] = parseInt(value) * 8;
                                break;
                            case 'Regular':
                                properties['Regular'] = parseInt(value) * 8;
                                break;
                            case 'Super':
                                properties['Super'] = parseInt(value) * 8;
                                break;
                            case 'Super+':
                                properties['Super+'] = parseInt(value) * 8;
                                break;
                        }
                        selections.push(data);
                    }
                });
        
                const bundle = {
                    "externalVariantId": bundleParentData.variantId,
                    "externalProductId": bundleParentData.productId,
                    "selections": selections
                };
        
                console.log(bundle);
                const rbId = await recharge.bundle.getBundleId(bundle);
        
                // Adds the value directly to the cart
                properties['_rb_id'] = rbId;
                properties['_referenced_product_handle'] = this.referencedProductHandle;
                const cartData = {
                    items: [{
                        id: bundleParentData.variantId,
                        quantity: bundleParentData.quantity,
                        properties: properties,
                        selling_plan: bundleParentData.sellingPlan
                    }]
                };
        
                const result = await fetch(window.Shopify.routes.root + 'cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(cartData),
                });
            }
        }
    );
}

if (!customElements.get("recharge-bundle-add-subscription-16ct")) {
    customElements.define(
        "recharge-bundle-add-subscription-16ct",
        class RechargeBundleAddSubscription16ct extends HTMLElement {
            constructor() {
                super();
                this.button = this.querySelector('button');
                this.referencedProductHandle = this.getAttribute('data-referenced-product-handle');
                this.storeIdentifier = this.getAttribute('data-store-identifier');
            }
        
            connectedCallback() {
                recharge.init({
                    storeIdentifier: this.storeIdentifier, // On Shopify this should be your myshopify.com domain
                    // required for Storefront API access
                    storefrontAccessToken: 'strfnt_f16386bfed7c30d02ab8e5bbd1f6286eaa93d2e54cca7c33875c6ead2007f2c7'
                });
                this.button.addEventListener('click', this.handleSubmit.bind(this));
                this.deliveryFrequencyWidget = document.querySelector('delivery-frequency-widget');
                this.customizableAssortment = document.querySelector('customizable-assortment');
                this.paymentOptionsWidget = document.querySelector('payment-options-widget');
            }
        
            async handleSubmit(e) {
                console.log('16ct bundle product');
                e.preventDefault();
        
                if (this.button.classList.contains('disabled')) return;
        
                this.button.classList.add('loading');
                this.button.classList.add('disabled');
        
                const bundleParentData = {
                    variantId: this.deliveryFrequencyWidget.selectedVariantId,
                    productId: this.deliveryFrequencyWidget.selectedProductId,
                    sellingPlan: this.deliveryFrequencyWidget.sellingPlan,
                    frequency: parseInt(this.deliveryFrequencyWidget.frequency),
                    internalUnit: this.deliveryFrequencyWidget.internalUnit
                }
        
                const aborbencies = this.customizableAssortment.absorbencyData;
                const bundleCollectionId = this.customizableAssortment.rechargeBundleCollectionId;
                const bundleSubProductId = this.customizableAssortment.rechargeBundleSubProductId;
                const bundleSubProductVariants = this.customizableAssortment.rechargeSubProductVariants;
                const selections = [];
                const properties = [];
        
                Object.entries(aborbencies).forEach(([key, value]) => {
                    if (value > 0) {
                        const data = {};
                        data.collection_id = bundleCollectionId;
                        data.collection_source = 'shopify';
                        data.external_product_id = bundleSubProductId;
                        data.quantity = parseInt(value);
                        data.external_variant_id = bundleSubProductVariants.find(v => v.title == key).id.toString();
                        switch (key) {
                            case 'Light':
                                properties.push({
                                    name: 'Light',
                                    value: `${parseInt(value) * 8}`
                                })
                                break;
                            case 'Regular':
                                properties.push({
                                    name: 'Regular',
                                    value: `${parseInt(value) * 8}`
                                });
                                break;
                            case 'Super':
                                properties.push({
                                    name: 'Super',
                                    value: `${parseInt(value) * 8}`
                                })
                                break;
                            case 'Super+':
                                properties.push({
                                    name: 'Super+',
                                    value: `${parseInt(value) * 8}`
                                });
                                break;
                        }
                        selections.push(data);
                    }
                });
        
                properties.push({
                    name: '_referenced_product_handle',
                    value: `${this.referencedProductHandle}`
                })
                
                const addressId = document.querySelector('#select_address_id').value;
                const next_charge_scheduled_at = document.querySelector('#next_charge_date').value;

                const subscription = {
                    properties: properties,
                    external_product_id: { ecommerce: bundleParentData.productId.toString() },
                    external_variant_id: { ecommerce: bundleParentData.variantId.toString() },
                    quantity: 1,
                    charge_interval_frequency: bundleParentData.frequency,
                    order_interval_frequency: bundleParentData.frequency,
                    order_interval_unit: bundleParentData.internalUnit,
                    address_id: addressId,
                    next_charge_scheduled_at: next_charge_scheduled_at,
                };

                const bundle = {
                    properties: properties,
                    external_product_id: { ecommerce: bundleParentData.productId.toString() },
                    external_variant_id: { ecommerce: bundleParentData.variantId.toString() },
                    items: selections,
                    charge_interval_frequency: bundleParentData.frequency,
                    order_interval_frequency: bundleParentData.frequency,
                    order_interval_unit: bundleParentData.internalUnit
                };

                console.log('bundle', bundle);
                try {
                    const session = await recharge.auth.loginShopifyAppProxy();
                    //create subscription
                    const newSubscription = await recharge.subscription.createSubscription(session, subscription);
                    const subscriptionID = newSubscription.id;

                    const updateSubscription = await recharge.bundle.updateBundle(session, subscriptionID, bundle);
                    //update bunlde children items. 
                    console.log('newSubscription', newSubscription);
                    console.log('updateSubscription', updateSubscription);
                    window.location.href = window.LOLA_PRODUCT.metadata.rechargeInfo.subscriptionsListUrl;
                } catch (error) {
                    console.log(error);
                }
            }

        }
    );
}